"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _uuid = require("uuid");

var _Tooltip = _interopRequireDefault(require("../../../../help/Tooltip/Tooltip"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ToolbarButton = ({
  children,
  onClick,
  tooltip,
  hideTooltipOnClick,
  disabled,
  ...otherProps
}) => {
  const buttonRef = (0, _react.useRef)();
  const id = (0, _uuid.v4)();
  const buttonClick = (0, _react.useCallback)(event => {
    if (hideTooltipOnClick && event && event.target) {
      event.target.blur();
    }

    onClick(event);
  }, [hideTooltipOnClick, onClick]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledToolbarButton, { ...otherProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      ref: buttonRef,
      type: "button",
      "data-tip": tooltip,
      "data-for": id,
      tabIndex: "-1",
      disabled: disabled,
      onClick: buttonClick,
      "aria-label": tooltip,
      ...otherProps,
      children: children
    }), !disabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
      id: id,
      delayShow: 1000,
      delayHide: 0
    })]
  });
};

ToolbarButton.propTypes = {
  tooltip: _propTypes.PropTypes.any.isRequired
};
var _default = ToolbarButton;
exports.default = _default;